import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* setPacingModeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getPacingModeOptions])
    const { entity } = response
    yield put(actions.setPacingModeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setPacingModeOptions() error: ${e}`))
  }
}
export function* setPacingModeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setPacingModeOptions)
}
